module.exports = __webpack_public_path__ + "img/25.515aaa41.jpg";